import React from 'react';
import { formatCurrency } from '../../utils/roadmapCalcs';
interface MoneyInputProps {
  value: number;
  onChange: (value: number) => void;
  label: string;
  /** Enter key submits the step, matching the Continue button. */
  onEnter?: () => void;
  autoFocus?: boolean;
  suffix?: string;
}
export function MoneyInput({
  value,
  onChange,
  label,
  onEnter,
  autoFocus = true,
  suffix
}: MoneyInputProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Accept whatever the visitor types, including commas and spaces, and keep
    // only the digits. Nobody should be told off for typing "$450,000".
    const digits = event.target.value.replace(/[^\d]/g, '');
    onChange(digits ? Number.parseInt(digits, 10) : 0);
  };
  return <div data-id="element-217" data-mp="gxojqovf4tdp">
      <label className="block" data-id="element-218" data-mp="3flvhmmb313hz">
        <span className="sr-only" data-id="element-219" data-mp="3fku3g8yrs0w1">{label}</span>
        <span className="flex items-center gap-2 px-5 py-4 rounded-2xl border-2 border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 focus-within:border-primary-500 transition-colors" data-id="element-220" data-mp="3fk13bqubg9mv">
          <span className="text-2xl font-bold text-slate-400 dark:text-slate-500" data-id="element-221" data-mp="1k9v0m64jmhsq">
            $
          </span>
          <input type="text" inputMode="numeric" autoComplete="off"
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus} value={value > 0 ? value.toLocaleString('en-AU') : ''} onChange={handleChange} onKeyDown={event => {
          if (event.key === 'Enter' && onEnter) onEnter();
        }} placeholder="0" aria-label={label} className="flex-1 min-w-0 bg-transparent text-2xl font-bold text-slate-900 dark:text-white placeholder:text-slate-300 dark:placeholder:text-slate-600 outline-none" data-id="element-222" data-mp="1ahxjkiqusvm3" />
          {suffix && <span className="text-base font-medium text-slate-400 dark:text-slate-500 whitespace-nowrap" data-id="element-223" data-mp="2lurp7rge4pxp">
              {suffix}
            </span>}
        </span>
      </label>

      {value > 0 && <p className="mt-3 text-sm text-slate-500 dark:text-slate-400" data-id="element-224" data-mp="jzk5fsxu9pb6">
          {formatCurrency(value)}
        </p>}
    </div>;
}